module.exports = __webpack_public_path__ + "img/NissanGTR.309b35fe.jpg";